<template>
  <div class="body">
    <div class="info">
      <div class="avatar">
        <img :src="userInfo.avatarurl" alt="">
      </div>
      <div class="tit">
        <div>{{userInfo.name||userInfo.nickname}}</div>
        <div>{{typeName(userInfo.birthday)}} | {{userInfo.gender==0?'未知':userInfo.gender==1?'男':'女'}}</div>
      </div>
      
    </div>
    <List :immediate-check='false' v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
      <RecordList :List="List" />
    </List>
    <Empty description="暂无数据" v-if="List.length===0" />
  </div>
</template>
<style lang="less" scoped>
@import url('./index.less');
</style>
<script>
import { Popup, Tab, Tabs, Empty, List } from "vant";
import RecordList from "./List/index";
export default {
  name: "EntryRecord",
  components: {
    vanTab: Tab,
    vanTabs: Tabs,
    RecordList,
    Empty,
    List,
  },
  data() {
    return {
      loading: false,
      finished: false,
      List: [],
      page: 1,
      userInfo: {}
    };
  },
  methods: {
    getList() {
      this.$toast.loading("加载中...");
      this.$api.user.getRecords({ page: this.page }).then((res) => {
        this.loading = false;
        let { list, page, pages } = res.data;
        if (page == 1) {
          this.List = list;
        } else {
          this.List = this.List.concat(list);
        }
        if (page >= pages) {
          this.finished = true;
        } else {
          this.page++;
        }
        this.$toast.clear();
      });
    },
    getUserInfo() {
        this.$api.user.getUserInfo().then((res) => {
            if (res.status * 1 === 200) {
                this.userInfo = res.data
            }
        })
    },
    typeName(birthday) {
      if(birthday) {
        var date = new Date(birthday)
        var time = Date.parse(date)/1000
        console.log(time)
        if (time<=1104422400&&time>=883584000) {
          return '青年组'
        } else if (time<=883497600&&time>=252432000) {
          return '壮年一组'
        } else if (time<=252345600&&time>=-220953600) {
          return '壮年二组'
        } else if (time<=-221040000&&time>=-536486400) {
          return '老年组'
        }
      }
      return '暂无分组'
    }
  },
  mounted() {
    this.$nextTick(() => {
        this.getList();
        this.getUserInfo()
    });
  },
};
</script>